<template>
  <b-modal
      id="1"
      :title="title"
      v-model="isOpenLocal"
      size="lg"
      scrollable
      :hide-footer="hideFooter"
      :ok-title="capitalize($t('validate'))"
      :cancel-title="capitalize($t('cancel'))"
      @hide="tryCloseModuleViewModal"
      @hidden="handleCancel"
      @ok="handleOk"
  >
    <validation-observer
        ref="observerRef"
        #default="{handleSubmit, errors}">
      <b-form @submit.prevent="handleSubmit(submitValidatedModuleViewLocal)">
        <form-module-view :module-view="moduleView"
                          :available-filters="availableFilters"
                          :available-sorts="availableSorts"
                          :available-global-amounts="availableGlobalAmounts"
                          :formErrors="errors"/>
        <button ref="submitModuleViewFormRef"
                class="d-none"></button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { ValidationObserver } from 'vee-validate'
import { capitalize } from '../../utils/filter'

import useAPI from '../../utils/useAPI'
import FormModuleView from '../form/ModuleView3.vue'

export default {
  components: {
    ValidationObserver,
    FormModuleView
  },
  props: {
    moduleView: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    fieldFilters: {
      type: Array,
      default: () => []
    },
    itemsContext: {
      type: Object,
      default: () => {}
    },
    availableFilters: {
      type: Array,
      default: () => []
    },
    availableSorts: {
      type: Array,
      default: () => []
    },
    availableGlobalAmounts: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isOpenLocal = ref(false)
    const moduleViewLocal = ref(props.moduleView)
    const submitModuleViewFormRef = ref(null)
    const observerRef = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { currentBreakPoint } = useAPI()

    const hideFooter = computed(() => {
      return !['xs', 'sm'].includes(currentBreakPoint.value)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(isOpenLocal, (val) => {
      emit('update:isOpen', val)
    })
    watch(moduleViewLocal, (val) => {
      emit('update:moduleView', val)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const tryCloseModuleViewModal = (modalEvent) => {
      if (modalEvent.trigger == 'backdrop') {
        // Click outside
        modalEvent.preventDefault()
        submitModuleViewFormRef.value.click()
      }
    }

    const submitValidatedModuleViewLocal = () => {
      emit('submitValidatedModuleView')
    }

    const handleOk = async (bvModalEvent) => {
      bvModalEvent.preventDefault()

      const isValid = await observerRef.value.validate()
      if (isValid) {
        submitValidatedModuleViewLocal()
      }
    }

    const handleCancel = () => {}

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      isOpenLocal,
      moduleViewLocal,
      submitModuleViewFormRef,
      observerRef,

      // Computed
      hideFooter,

      // Methods
      tryCloseModuleViewModal,
      submitValidatedModuleViewLocal,
      handleOk,
      handleCancel,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    moduleView: function (val) {
      this.moduleViewLocal = val
    },
    isOpen: function (val) {
      this.isOpenLocal = val
    }
  },
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>